import React, { useContext, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import { SettingsContext } from "../../../contexts";
import QuotesView from "./QuotesView";

/**
 * `panel` — rendered as the Orders page's right-hand panel rather than inline in a list row.
 * There the open quote is the PANEL's state (`quoteId` / `onSelectQuote`), not the URL's:
 * `/requests/orders/:id/:quoteId` matches a different <Route> element, so pushing it remounted
 * the page and closed the panel the quote was being opened from.
 */
const Quotes = ({ item, refreshParent, panel = false, quoteId, onSelectQuote }) => {
  const settings = useContext(SettingsContext);
  const params = useParams();
  const history = useHistory();
  const [refreshList, setRefreshList] = useState(0);
  const [type, setType] = useState(item.request_type || "order");
  const onQuoteSaved = () => {
    setRefreshList(refreshList + 1);
    // Not in the panel: there refreshParent re-keys the whole OrderQuotesDrawer,
    // which threw away the open quote and closed the editor on every SAVE /
    // approve. The list above already refreshes (refreshList + the ["quotes"]
    // invalidation in useUpsertQuote), which is all that re-mount was for.
    if (!panel) refreshParent?.();
  };

  if (panel) {
    return (
      <QuotesView
        {...{
          item,
          panel,
          quoteId,
          selectQuote: (id) => onSelectQuote?.(id),
          onQuoteSaved,
          refreshList,
        }}
        type={type}
        setType={setType}
      />
    );
  }

  return (
    <QuotesView
      {...{
        item,
        quoteId: params.quoteId,
        // Audit fix: previous URL built `?{params}/ai-extraction` which
        // dropped /ai-extraction into the query string and broke tab
        // routing. Build a proper path then append the query.
        selectQuote: (quoteId) => {
          const owner = history.location.pathname.split("/").slice(1, 3).join("/");
          const tabPath = quoteId === null ? "" : "/ai-extraction";
          const path = quoteId === null
            ? `/${owner}/${params.requestId}`
            : `/${owner}/${params.requestId}/${quoteId}${tabPath}`;
          history.push(`${path}?${settings.iframeQueryParams}`);
        },
        onQuoteSaved,
        refreshList,
      }}
      type={type}
      setType={setType}
    />
  );
};

export default Quotes;
